import XIcon from "@mui/icons-material/Close"
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material"
import { DialogProps } from "@/dialogs"
import { useForm } from "react-hook-form"
import { z } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import ControlledTextInput from "@/components/controlledInputs/ControlledTextInput"

interface ExpandNearYouDialog extends DialogProps {}

const expandFormSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string(),
  location: z.string(),
  highestLevelEducation: z.string(),
  desiredPay: z.string(),
  linkedIn: z.string(),
  description: z.string(),
})
export type ExpandFormDataType = z.infer<typeof expandFormSchema>
const defaultValues: ExpandFormDataType = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  location: "",
  highestLevelEducation: "",
  desiredPay: "",
  linkedIn: "",
  description: "",
}

export default function ExpandNearYouDialog({
  isOpen,
  closeDialog,
}: ExpandNearYouDialog) {
  function handleClose() {
    closeDialog()
  }

  const {
    // handleSubmit,
    // reset,
    control,
    // setValue,
    // formState: { errors },
  } = useForm<ExpandFormDataType>({
    resolver: zodResolver(expandFormSchema),
    defaultValues: defaultValues,
  })
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        minWidth={"500px"}
        pl={3}
        pr={1}
        py={1}
        sx={{
          backgroundColor: "white",
          color: "black",
        }}
      >
        <Typography>Expand Near You</Typography>
        <Box>
          <IconButton color="inherit" onClick={handleClose}>
            <XIcon />
          </IconButton>
        </Box>
      </Stack>
      <DialogContent
        sx={{
          py: 2,
        }}
      >
        <form action="https://formsubmit.co/info@843hub.com" method="POST">
          <Typography>
            Ready to bring the hub to your area?
            <br />
            <br />
            Book a meeting with us to explore exciting franchising opportunities
            and learn how you can become part of our growing network.
          </Typography>
          <Divider sx={{ padding: 2 }} />
          <Typography sx={{ pt: 2 }}>Your Info:</Typography>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Stack spacing={2} pt={2}>
              <ControlledTextInput
                control={control}
                name="firstName"
                label="First Name"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="lastName"
                label="Last Name"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="email"
                label="Email"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="phone"
                label="PhoneNumber"
                variant="filled"
              />
            </Stack>
            <Stack spacing={2} pt={2}>
              <ControlledTextInput
                control={control}
                name="location"
                label="Location"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="highestLevelEducation"
                label="Highest Level of Education"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="desiredPay"
                label="Desired Pay"
                variant="filled"
                type="number"
              />
              <ControlledTextInput
                control={control}
                name="linkedIn"
                label="Link to LinkedIn"
                variant="filled"
              />
            </Stack>
          </Box>
          <Box paddingTop={2}>
            <ControlledTextInput
              control={control}
              name="description"
              label="Description"
              variant="filled"
              multiline={true}
              formInputStyling={{ width: "100%" }}
            />
          </Box>
          <Typography pt={2}>
            Thank you for interest in joining our team, we will follow up with
            you.
          </Typography>
          <Divider sx={{ paddingTop: 2 }} />
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={2}
            mt={3}
          >
            <Button variant="text" color="inherit" onClick={closeDialog}>
              Cancel
            </Button>

            <Button
              variant="contained"
              type="submit"
              color="primary"
              onClick={() => {
                closeDialog()
              }}
            >
              Send
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  )
}
